export class Support {

  firstname: string | undefined;
  lastname: string | undefined;
  company: string | undefined;
  email: string | undefined;
  problem: string | undefined;
  message: string | undefined;
}

export module Support {
  export enum Problem {
    MAPPING = 'support.problems.mapping',
    SOURCE = 'support.problems.source',
    ASSIGN = 'support.problems.assign',
    ACCOUNT = 'support.problems.account',
    EXPORT = 'support.problems.export',
    CREATE = 'support.problems.create',
    LAUNCH = 'support.problems.launch',
    OTHER = 'support.problems.other'
  }
}
